function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useEffect } from 'react';
import { ImageManage } from '../../../models/image';
import { useSingleton } from '@bydesign-ui/hooks';
export function useImageManage(file, options) {
  var _options$imageType = options.imageType,
      imageType = _options$imageType === void 0 ? 'image/jpeg' : _options$imageType,
      extra = _objectWithoutProperties(options, ["imageType"]);

  var imageManage = useSingleton(function () {
    return new ImageManage();
  });
  imageManage.updateImageOptions(extra);
  useEffect(function () {
    if (file == null) {
      return;
    }

    if (typeof file === 'string') {
      imageManage.initImage(file, imageType);
    } else {
      imageManage.initImage(file);
    }

    return function () {
      imageManage.dispose();
    };
  }, [file]);
  return imageManage;
}